import 'css-chunksrc/client/scenes/project/resources/menu/styles.scss';export default {
  "menu": "_menu_46n8d_1",
  "addResourceButton": "_addResourceButton_46n8d_6",
  "icon": "_icon_46n8d_11",
  "iconBox": "_iconBox_46n8d_16",
  "visible": "_visible_46n8d_22",
  "list": "_list_46n8d_34",
  "item": "_item_46n8d_50",
  "name": "_name_46n8d_64"
};